import {CSSProperties, FC} from 'react';


export interface IIconCartProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCart: FC<IIconCartProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M6.483 7.508 4 5.066 5.083 4l2.482 2.443h11.67a.77.77 0 0 1 .614.303c.144.191.188.438.119.666l-1.838 6.026a.764.764 0 0 1-.733.537H8.014v1.506h8.421v1.506H7.248a.76.76 0 0 1-.765-.753V7.508Zm1.531.441v4.52h8.813l1.378-4.52H8.014ZM7.631 20a1.14 1.14 0 0 1-1.148-1.13c0-.624.514-1.13 1.148-1.13a1.14 1.14 0 0 1 1.149 1.13A1.14 1.14 0 0 1 7.63 20Zm9.187 0a1.14 1.14 0 0 1-1.148-1.13c0-.624.514-1.13 1.148-1.13a1.14 1.14 0 0 1 1.148 1.13A1.14 1.14 0 0 1 16.819 20Z" clipRule="evenodd" />
        </svg>
    );
};
